import React from 'react';
import Button from './Button';
import Field from './Field';

const UserCreate = () => (
  <div className="ui form">
    <Field />
    <Button />
  </div>
);

export default UserCreate;
